import React from 'react';
import { BsArrowLeft } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import './FloatingButton.css';

export const FloatingButton = () => {
    const navigate = useNavigate();
    const handleClick = () => {
        navigate(-1);
    };

    return (
        <button className="floating-button" onClick={handleClick}>
            <BsArrowLeft />
        </button>
    );
};